import { useMemo, useState } from "react";
import { useNavigate } from 'react-router-dom';
import * as data from "./data";
import add_circle from '../images/add_circle.png'
import moment from "moment";
import { fullStates, suffix } from "./constants/constants";
import { countryOptions } from "./constants/countryOptions";
import { useEffect } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Inputmask from "inputmask";
import { useAuth } from "../context/AuthContext";

const MyForm = () => {
    const navigate = useNavigate();
    const {roles, email} = useAuth();
    const [akaDateErr, setAkaDateErr] = useState([]);
    const [vehicleErr, setVehicleErr] = useState("");
    const [searchOrder, setSearchOrder] = useState([])
    const [validForm, setValidForm] = useState(true);
    const [count, setCount] = useState(0);
    const [isRed, setIsRed] = useState("form-control is-invalid")
    const [invalidDOB, setInvalidDOB] = useState(false);
    const [showError, setShowError] = useState(false);
    const [selectedStates, setSelectedStates] = useState(() => {
        return Array.isArray(data.formData.Body.DriverRequest.DriverLicense.LicenseState) ? data.formData.Body.DriverRequest.DriverLicense.LicenseState : [];
    });
    const codeToLabel = useMemo(
    () => Object.fromEntries(countryOptions.US.map(s => [s.code, s.label])),
    []
    );
    const [warnings, setWarnings] = useState({
        lastTrun: '',
        firstTrun: '',
        middleTrun: '',
        akaLastTrun: ['', '', ''],
        akaFirstTrun: ['', '', ''],
        akaMiddleTrun: ['', '', ''],
        lastTran: '',
        firstTran: '',
        middleTran: '',
        akaLastTran: ['', '', ''],
        akaFirstTran: ['', '', ''],
        akaMiddleTran: ['', '', '']
    });




    let dp = new Date().toISOString().split('T')[0];
    const [y,m,d] = dp.split('-');
    const yn = y - 21;
    const ny = yn+'-'+m+'-'+d; 
    //data?.setDriverDOB(ny)

    const handleSetCnDob = () => {
        let dp = new Date().toISOString().split('T')[0];
        const [y,m,d] = dp.split('-');
        const yn = y - 21;
        const ny = yn+'-'+m+'-'+d; 
        data?.setDriverDOB(ny);
        //data.DriverAkaDOB(ny)
    }

    const formatDOB = (dob) => dob ? moment(dob).format("MM/DD/YYYY") : "";
    
    useEffect(() => {

        const fields = [
        'DriverLastNameTrunCode', 'DriverLastNameTranCode',
        'DriverFirstNameTrunCode', 'DriverFirstNameTranCode',
        'DriverMiddleNameTrunCode', 'DriverMiddleNameTranCode',
        'AkaLastNameTrunCode', 'AkaLastNameTranCode',
        'AkaFirstNameTrunCode', 'AkaFirstNameTranCode',
        'AkaMiddleNameTrunCode', 'AkaMiddleNameTranCode'
        ];

        fields.forEach((fieldName) => {
            const val = localStorage.getItem(fieldName);
            const checked = val === 'T';
            let checkboxes;
            if(fieldName.includes('Aka')){
                const {index, field} = fieldName.split(':');
                checkboxes = document.querySelector(`input[name="${field}"][data-input="${index}"]`);
            } else{
                checkboxes = document.getElementsByName(fieldName);
            } 
            
            checkboxes?.forEach(cb => { cb.checked = checked; });

            let inputName = '';
            if (fieldName.includes('LastName')) inputName = fieldName.includes('Aka') ? 'AkaLastName' : 'DriverLastName';
            else if (fieldName.includes('FirstName')) inputName = fieldName.includes('Aka') ? 'AkaFirstName' : 'DriverFirstName';
            else if (fieldName.includes('MiddleName')) inputName = fieldName.includes('Aka') ? 'AkaMiddleName' : 'DriverMiddleName';
        });
        data.formData.Body.DriverRequest.DriverData.DriverNameAka.forEach((aka, index) => {
            ['AkaLastName', 'AkaFirstName', 'AkaMiddleName'].forEach((nameField) => {
                const trunField = `${nameField}TrunCode`;
                const tranField = `${nameField}TranCode`;

                // read values saved per-index, e.g. "AkaLastNameTrunCode:0" -> "T"
                const trunVal = localStorage.getItem(`${trunField}:${index}`);
                const tranVal = localStorage.getItem(`${tranField}:${index}`);

                const trunEl = document.querySelector(`input[name="${trunField}"][data-input="${index}"]`);
                const tranEl = document.querySelector(`input[name="${tranField}"][data-input="${index}"]`);
                if (trunEl) trunEl.checked = trunVal === 'T';
                if (tranEl) tranEl.checked = tranVal === 'T';
            });
        });
        // Mask main Driver DOB (there may be multiple in different queryType branches)
        const driverDobEls = document.querySelectorAll('input[name="DriverDOB"]');
        const akaDobEls    = document.querySelectorAll('input[name="DriverAkaDOB"]');

        const im = new Inputmask("99/99/9999", {
            placeholder: "MM/DD/YYYY",
            showMaskOnHover: false,
            showMaskOnFocus: true,
            clearIncomplete: true,
            rightAlign: false,
            positionCaretOnClick: "lvp",   // "last valid position" – lets you edit inside the string
            insertMode: true,              // keeps insert behavior natural
            insertModeVisual: true,
        });

        driverDobEls.forEach(el => im.mask(el));
        akaDobEls.forEach(el => im.mask(el));
  }, [count]);
    
  const country = data.selectionRequest.country === "OTHER" ? "OTH" : data.selectionRequest.country === "US_TERRITORIES" ? "US-T" : data.selectionRequest.country;
    data.setLicenseCountry(country);

    const licenseStateMissing =
    data.formData.Body.DriverRequest.DriverLicense.LicenseState === null ||
    data.formData.Body.DriverRequest.DriverLicense.LicenseState === "";

    // Only set license state for specific searches
    const shouldSetLicenseState = [
    'statussearch',
    'historysearch',
    'inquirysearch',
    'akasearch'
    ].includes(data.selectionRequest.queryType);

    function ShowState({st}){
        let ret = ""
        countryOptions.US.forEach((v) => {
            if(v.code === st){
                ret = v.label;
            } 
        })
        return(<>{ret}</>)
    }

    if (licenseStateMissing && shouldSetLicenseState) {
        console.log(data.selectionRequest.jurisdiction);
        console.log(data.selectionRequest.jurisdiction.code.toUpperCase());
        data.setLicenseState(data.selectionRequest.jurisdiction.code.toUpperCase());
    }

    const disableKey  = (event) =>{ 
        event.preventDefault();
        const { name, value } = event.target;
        if(formatDOB(value)){
                return;
        }
    }
    
    
    const handleLicenseChange = (e) => {

        e.target.setCustomValidity('');
        switch(e.target.name){
            case 'LicenseNumber':
                data.setLicenseNumber(e.target.value);
                break;
            case 'LicenseState':
                data.setLicenseState(e.target.value.toUpperCase());
                if(data.formData.Body.DriverRequest.DriverLicense.LicenseState.length !== 2){
                    setIsRed("required-input")
                } else {
                    setIsRed("")
                }
                break;
            case 'LicenseCountry':
                data.setLicenseCountry(e.target.value);
                break;
            default:
                break; 
        }
        console.log("Value from license: ", data.formData.Body.DriverRequest.DriverLicense[e.target.name])
    };
    const handleNameChange = (e) => {
        e.target.setCustomValidity('');
        const { name, value } = e.target;
        const newWarnings = { ...warnings };
        switch (name) {
        case 'DriverFirstName':
            data.setDriverFistName(value);
            if (document.getElementsByName("DriverFirstNameTrunCode")[0]?.checked && value.trim().length >= 40) newWarnings.firstTrun = '';
            if (document.getElementsByName("DriverFirstNameTranCode")[0]?.checked && value.trim().length >= 1) newWarnings.firstTran = '';
            break;
        case 'DriverMiddleName':
            data.setDriverMiddleName(value);
            if (document.getElementsByName("DriverMiddleNameTrunCode")[0]?.checked && value.trim().length >= 35) newWarnings.middleTrun = '';
            if (document.getElementsByName("DriverMiddleNameTranCode")[0]?.checked && value.trim().length >= 1) newWarnings.middleTran = '';
            break;
        case 'DriverLastName':
            data.setDriverLastName(value);
            if (document.getElementsByName("DriverLastNameTrunCode")[0]?.checked && value.trim().length >= 40) newWarnings.lastTrun = '';
            if (document.getElementsByName("DriverLastNameTranCode")[0]?.checked && value.trim().length >= 1) newWarnings.lastTran = '';
            break;
        case 'Suffix':
            data.setDriverSuffix(value);
            break;
        default:
            break;
        }
        setWarnings(newWarnings);
  
    };
    const handleDataChange = (e) => {
        e.target.setCustomValidity('');
        switch(e.target.name){
            case 'SSN':
                data.setDriverSSN(e.target.value);
                break;
            case 'DriverDOB':
                setInvalidDOB(false);
                data.setDriverDOB(moment(e.target.value).format("YYYY-MM-DD"));
                break;
            case 'Age':
                data.setDriverAge(e.target.value);
                break;
            case 'YearSearchRange':
                data.setYearSearchRange(e.target.value);
                break;
            case 'FirstMatchSequence':
                data.setFirstMatchSequence(e.target.value);
                break;
            case 'MessageMatchCount':
                data.setMessageMatchCount(e.target.value);
                break;
            default:
                break; 
        }
    };
    const handleVehicleChange = (e) => {
        console.log(e.target.name, e.target.value)
        switch(e.target.name){
            case 'VIN':
                data.setVIN(e.target.value);
                break;
            case 'RFC':
                data.setRFC(e.target.value);
                break;
            case 'Plate':
                data.setPlate(e.target.value);
                break;
            default:
                break; 
        }
    };
    const handleAkaChange = (e) => {
        e.target.setCustomValidity('');
        const { name, value, id, type, checked, dataset } = e.target;
        let index = 0;
        if (dataset && dataset.index !== undefined) {
            index = Number(dataset.index);
        } else {
            const m = /aka(\d+)/i.exec(id || '');
            index = m ? Math.max(0, Math.min(2, parseInt(m[1], 10) - 1)) : 0; // clamp to [0..2]
        }
        const newWarnings = { ...warnings };

        if (type === 'checkbox') {
            const val = checked ? 'T' : 'N';
            
            localStorage.setItem(`${name}:${e.target.dataset.input}`, value);

            data.updateAKA(index, name, val);

            let inputName = '';
            let fieldKey = '';
            let label = '';
            let max = 40;

            if (name.includes('LastName')) {
            inputName = 'AkaLastName';
            fieldKey = name.includes('Trun') ? 'akaLastTrun':'akaLastTran';
            label = 'AKA Last Name';
            } else if (name.includes('FirstName')) {
            inputName = 'AkaFirstName';
            fieldKey = name.includes('Trun') ? 'akaFirstTrun':'akaFirstTran';
            label = 'AKA First Name';
            } else if (name.includes('MiddleName')) {
            inputName = 'AkaMiddleName';
            fieldKey = name.includes('Trun') ? 'akaMiddleTrun':'akaMiddleTran';
            label = 'AKA Middle Name';
            max = 35;
            }

            const inputs = document.getElementsByName(inputName);
            const input = inputs[index];
            if (input) {
            // input.required = val === 'T';
            const length = (input.value || '').trim().length;

            if (name.includes('TrunCode') && checked && length < max) {
                newWarnings[fieldKey][index] =
                `The ${label} ${index+1} truncation field is set and the name length is less than ${max} characters.`;
            } else if(name.includes('TranCode') && checked && length < 1){
               newWarnings[fieldKey][index] =
                    `${label} ${index+1} is required when the ${label} Transliteration field is present.`; 
            }else {
                newWarnings[fieldKey][index] = '';
            }
            }
        } else {
            data.updateAKA(index, name, value);
            if(name === 'DriverAkaDOB'){
                setInvalidDOB(false);
            }
            if (name === 'AkaLastName'){
                if(document.getElementsByName('AkaLastNameTrunCode')[index]?.checked && value.trim().length >= 40) {
                    newWarnings.akaLastTrun[index] = '';
                }
                if(document.getElementsByName('AkaLastNameTranCode')[index]?.checked && value.trim().length >= 1) {
                    newWarnings.akaLastTran[index] = '';
                }
            } else if (name === 'AkaFirstName'){
                if(document.getElementsByName('AkaFirstNameTrunCode')[index]?.checked && value.trim().length >= 40) {
                    newWarnings.akaFirstTrun[index] = '';
                }
            } else if (name === 'AkaMiddleName'){
                if(document.getElementsByName('AkaMiddleNameTranCode')[index]?.checked && value.trim().length >= 1) {
                    newWarnings.akaMiddleTran[index] = '';
                }
                if(document.getElementsByName('AkaFirstNameTrunCode')[index]?.checked && value.trim().length >= 40) {
                    newWarnings.akaFirstTrun[index] = '';
                }
            } else if (name === 'AkaMiddleName'){
                if(document.getElementsByName('AkaMiddleNameTranCode')[index]?.checked && value.trim().length >= 1) {
                    newWarnings.akaMiddleTran[index] = '';
                }
            }
                
        }

        setWarnings(newWarnings);
        };

        //alert(JSON.stringify(selectedStates))
    const handleSelectChange = (code, checked) => {
        setSelectedStates((prev) => {
            let updated;
            if (checked) {
                // Add only if less than 10 already
                if (prev.length >= 10) return prev;
                updated = [...prev, code];
            } else {
                // Remove if unchecked
                updated = prev.filter((item) => item !== code);
            }

            // Optional: if you want to store in your existing data object too
            data.setLicenseState([...updated]);

            return updated;
        });
    };
    const clearSelected = () => {
        setSelectedStates([]);
        data.setLicenseState([]);
    };
    const toggleRequired = (e) => {
        const { name, checked, id, dataset } = e.target;
        const val = checked ? 'T' : 'N';
        localStorage.setItem(name, val);
        let index = 0;
        if (dataset && dataset.index !== undefined) {
            index = Number(dataset.index);
        } else {
            const m = /aka(\d+)/i.exec(id || '');
            index = m ? Math.max(0, Math.min(2, parseInt(m[1], 10) - 1)) : 0;
        }
        let inputName = '';
        let fieldKey = '';
        let label = '';
        let max = 40;
        const isAka = name.includes('Aka');

        if (name.includes('LastName')) {
            inputName = isAka ? 'AkaLastName' : 'DriverLastName';
            fieldKey = isAka ? 'akaLast' : 'last';
            label = isAka ? 'AKA Last Name' : 'Last Name';
        } else if (name.includes('FirstName')) {
            inputName = isAka ? 'AkaFirstName' : 'DriverFirstName';
            fieldKey = isAka ? 'akaFirst' : 'first';
            label = isAka ? 'AKA First Name' : 'First Name';
        } else if (name.includes('MiddleName')) {
            inputName = isAka ? 'AkaMiddleName' : 'DriverMiddleName';
            fieldKey = isAka ? 'akaMiddle' : 'middle';
            label = isAka ? 'AKA Middle Name' : 'Middle Name';
            max = 35;
        }
        if(name.includes('Trun')){
            fieldKey += 'Trun'
        } if(name.includes('Tran')){
            fieldKey += 'Tran'
        }
        const inputs = document.getElementsByName(inputName);
        const input = inputs.length ? inputs[index] : null;
        if (input) {
            // input.required = val === 'T';
            const length = input.value.trim().length;

            const newWarnings = { ...warnings };
            if (name.includes("TrunCode") && checked && length < max) {
                if (isAka) {
                    newWarnings[fieldKey][index] =
                    `The ${label} truncation field is set and the name length is less than ${max} characters.`;
                } else {
                    newWarnings[fieldKey] =
                    `The ${label} truncation field is set and the ${label.toLowerCase()} length is less than ${max} characters.`;
                }
            } else if(name.includes("TranCode") && checked && length < 1){
                if (isAka) {
                    newWarnings[fieldKey][index] =
                    `${label} is required when the ${label} Transliteration field is present.`;
                } else {
                    newWarnings[fieldKey] =
                    `${label} is required when the ${label} Transliteration field is present.`;
                }
            } else {
                if (isAka) newWarnings[fieldKey][index] = '';
                else newWarnings[fieldKey] = '';
            }
            setWarnings(newWarnings);
        }

        // Make sure uiState reflects the change
        if (isAka) {
            data.setAkaTrunTran(index, name);
        } else {
            data.setTrunTran(name);
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        data.setErrorReceived([]);
        setShowError(false);
        setInvalidDOB(false);
        let invalid = false;
        let dateErr = []

        if(e.target.DriverDOB?.value && (!moment(e.target.DriverDOB.value, "YYYY-MM-DD", true).isValid() || 
            moment(e.target.DriverDOB.value).isAfter(moment()))){
            dateErr.push(<div>Please enter a valid DOB in MM/DD/YYYY format.</div>);
            setInvalidDOB(true);
            invalid = true;
        }
        const akaDOBs = document.querySelectorAll('input[name="DriverAkaDOB"]');
        console.log("AKA DOBs: ", akaDOBs);
        akaDOBs?.forEach((dobInput, indx) => {
            if(dobInput?.value && (!moment(dobInput.value, "YYYY-MM-DD", true).isValid() || moment(dobInput.value).isAfter(moment()))){
                dateErr.push(<div>Please enter a valid AKA {indx + 1} DOB in MM/DD/YYYY format.</div>);
                setInvalidDOB(true);
                invalid = true;
            }
        });

        if(e?.target?.DriverDOB?.value !== undefined){
          const [ year, month, day ] = e?.target?.DriverDOB?.value.split("-");

            if(month > 12){
            dateErr.push(<div>The Field MM must be between 1 and 12</div>);
            invalid = true; 
            }

            if(day > 31){
                dateErr.push(<div>The field DD must be between 1 and 31</div>);
                invalid = true;
            }
        }

        const hasWarnings = Object.values(warnings).some(value => {
            if (Array.isArray(value)) {
            return value.some(inner => inner && inner.trim() !== "");
            }
            return value && value.trim() !== "";

        });

        if (hasWarnings) {
            setShowError(true);
            invalid = true;
        }

        if(invalid){
            setAkaDateErr(dateErr)
            return;
        }

        switch(data.selectionRequest.queryType){
            case 'statussearch':
                navigate('/statusresults');
                break;
            case 'historysearch':
                navigate('/historyresults');
                break;
            case 'akasearch':
                const source = data.uiState?.akaList ?? [];
                //alert(JSON.stringify(data))
                const cleaned = source.filter(row => {
                    return (
                    row.AkaFirstName?.trim() ||
                    row.AkaMiddleName?.trim() ||
                    row.AkaLastName?.trim() ||
                    row.DriverAkaDOB?.trim() ||
                    row.Suffix?.trim()
                    );
                });
                data.updateAKAListData(cleaned);
                console.log("JJ :"+JSON.stringify(data.formData));
                const checker = data.formData.Body.DriverRequest.DriverData.DriverNameAka
                //alert(JSON.stringify(checker))
                let errs = [];
                checker.forEach((v) => {
                    if((v.AkaLastName !==  '') && (v.DriverAkaDOB === '')){
                        setShowError(true);
                        invalid = true;
                        errs.push(<div>If a last name is entered a DOB is required</div>)
                    }
                
                    if((v.AkaLastName ===  '') && (v.DriverAkaDOB !== '')){
                        setShowError(true);
                        invalid = true;
                        errs.push(<div>If a DOB is entered a last name is required</div>)
                    }
                })
                setAkaDateErr(errs)
                if(errs.length > 0){
                    return;
                }
                navigate('/akaresults');
                break;
            case 'inquirysearch':
                navigate('/inquiryresults');
                break;
            case 'vehiclesearch':
                if(e.target.VIN.value === '' && e.target.RFC.value === '' && e.target.Plate.value === ''){
                    setVehicleErr("At least one of the fields must be filled out");
                    setValidForm(false);
                } else if((e.target.VIN.value !== '' && e.target.RFC.value !== '') ||
                (e.target.RFC.value !== '' && e.target.Plate.value !== '') ||
                (e.target.VIN.value !== '' && e.target.Plate.value !== '')){
                    setVehicleErr("Please limit your search criteria to one of the following fields: Plate or VIN or RFC.");
                    setValidForm(false);
                }else {
                    data.removeEmptyObjects(data.removeEmptyFields(data.formData));
                    navigate('/vehicleresults')
                }
                
                break;
            case 'minimalsearch':
            /* 
            if(selectedStates.length === 0){
                    setShowError("No states Selected");
                    return;
                }
                    */
                if(typeof data.formData.Body.DriverRequest.DriverLicense.LicenseState === 'string') {
                    data.setLicenseState(null);
                }
                const request = data.removeEmptyObjects(data.removeEmptyFields(data.formData));
                console.log("Minimal Search Data: ", request);
                navigate('/minimalresults')
                break;
            default:
                break; 
        }
    }

    //alert(JSON.stringify(data.formData?.Body?.DriverRequest?.DriverData?.DriverDOB))
    
    switch (data.selectionRequest.queryType) {

        case 'statussearch':
            return(<div id='table'>
                <div id='banner-search'>
                    <h4>Request for Driver Status</h4>
                </div>
                <div hidden={validForm}>
                    <span>Form invalid</span>
                </div>
                <form className='form' id="Index-form" onSubmit={handleSubmit}>
                    <span style={{ color: 'red', fontSize: 'small' }}>{akaDateErr}</span>                           
                    {showError && (
                    <div style={{ color: 'red', fontSize: 'small' }}>
                        {Object.entries(warnings).map(([key, value]) => {
                        if (Array.isArray(value)) {
                            // For array warnings like akaLastTrun
                            return value
                            .filter(v => v) // remove empty strings
                            .map((msg, i) => <div key={`${key}-${i}`}>{msg}</div>);
                        } else if (value) {
                            // For single string warnings
                            return <div key={key}>{value}</div>;
                        }
                        return null; // skip empty
                        })}
                    </div>
                    )}
                    <div className="row">
                    <div className="col-md-3 mb-3">
                            <label for="state">State</label>
                            <input type="text" 
                                placeholder="State" minLength={2} maxLength={2} 
                                pattern="^[A-Za-z0-9]{2}$" 
                                className="form-control"
                                id="required-input"
                                onInvalid={(e) => e.target.setCustomValidity('Invalid Jurisdiction entered')} 
                                name="LicenseState" style={{textTransform:'uppercase'}}
                        defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseState} onChange={handleLicenseChange} required/>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label for="dlNumber">Driver License Number</label>
                            <input type="text" className="form-control is-invalid" id="required-input" placeholder="" name="LicenseNumber" maxLength={27} pattern="^[a-zA-Z0-9-]*$" style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseNumber} onChange={handleLicenseChange} required/>
                            
                        </div>
                    </div>
                    
                    <div className="row" id="DLNTrun">
                        <div className="col-md-6">
                            <label for="inputLastName" className="form-label">Last Name</label>
                            <input type="text" className="form-control"  name="DriverLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTrunCode} id="DriverLastNameTrunCode" name="DriverLastNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverLastNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTranCode}  id="DriverLastNameTranCode" name="DriverLastNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverLastNameTranCode">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputFirstName" className="form-label">First Name</label>
                            <input type="text" className="form-control" name="DriverFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstName} onChange={handleNameChange} /> 
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTrunCode}  id="DriverFirstNameTrunCode" name="DriverFirstNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverFirstNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTranCode}  id="DriverFirstNameTranCode" name="DriverFirstNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverFirstNameTranCode">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputMiddleName" className="form-label">Middle Name</label>
                            <input type="text" className="form-control" name="DriverMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={35} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTrunCode} id="DriverMiddleNameTrunCode" name="DriverMiddleNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverMiddleNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTranCode} id="DriverMiddleNameTranCode" name="DriverMiddleNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverMiddleNameTranCode">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label for="suffix">Suffix</label>
                            <select className="form-control form-select" name="Suffix" placeholder="" id="suffix" onChange={handleNameChange}>
                            <option defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.Suffix}> -- Suffix -- </option>
                                {suffix.map((val) => (
                                <option value={val}>{val}</option>
                            ))}
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="ssn">SSN</label>
                            <input type="text" className="form-control" name="SSN" minLength={9} maxLength={9} onInvalid={(e) => e.target.setCustomValidity('Invalid SSN')} pattern="^[0-9]{9}$" placeholder=""
                            defaultValue={data.formData.Body.DriverRequest.DriverData.SSN} onChange={handleDataChange} />
                        </div>
                        <div className="col-md-5">
                            <label for="inputDOB" className="form-label">Date of Birth</label>
                              <input type="date" className="form-control"
                                    placeholder="MM/DD/YYYY" 
                                    onKeyDown={(e) => disableKey(e)}
                                    name='DriverDOB'
                                    onClick={handleSetCnDob}
                                    defaultValue={formatDOB(data.formData?.Body?.DriverRequest?.DriverData?.DriverDOB)} 
                                    onChange={handleDataChange} max={moment().format("YYYY-MM-DD")}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' />
                        </div>
                    </div>
                    
                    </form>
                    <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                    <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>
                    
            </div>);
        case 'historysearch':
            return(<div id='table'>
                <div id='banner-search'>
                    <h4>Request for Driver History</h4>
                </div>
                <div hidden={validForm}>
                    <span>Form invalid</span>
                </div>
                <form className='form' id="Index-form" onSubmit={handleSubmit}>
                    <span style={{ color: 'red', fontSize: 'small' }}>{akaDateErr}</span>                           
                    {showError && (
                    <div style={{ color: 'red', fontSize: 'small' }}>
                        {Object.entries(warnings).map(([key, value]) => {
                        if (Array.isArray(value)) {
                            // For array warnings like akaLastTrun
                            return value
                            .filter(v => v) // remove empty strings
                            .map((msg, i) => <div key={`${key}-${i}`}>{msg}</div>);
                        } else if (value) {
                            // For single string warnings
                            return <div key={key}>{value}</div>;
                        }
                        return null; // skip empty
                        })}
                    </div>
                    )}
                    <div className="row">
                    <div className="col-md-3 mb-3">
                            <label for="state">State</label>
                            <input type="text" className="form-control is-invalid" id="required-input" placeholder="State" minLength={2} maxLength={2} pattern="^[A-Za-z0-9]{2}$" onInvalid={(e) => e.target.setCustomValidity('Invalid Jurisdiction entered')} name="LicenseState" style={{textTransform:'uppercase'}}
                        defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseState} onChange={handleLicenseChange} required/>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label for="dlNumber">Driver License Number</label>
                            <input type="text" className="form-control is-invalid" id="required-input" placeholder="" name="LicenseNumber" maxLength={27} pattern="^[a-zA-Z0-9-]*$" style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseNumber} onChange={handleLicenseChange} required/>
                            
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputLastName" className="form-label">Last Name</label>
                            <input type="text" className="form-control"  name="DriverLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTrunCode}  id="DriverLastNameTrunCode" name="DriverLastNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverLastNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTranCode}    id="DriverLastNameTranCode" name="DriverLastNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="transliterated">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputFirstName" className="form-label">First Name</label>
                            <input type="text" className="form-control" name="DriverFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTrunCode}  id="DriverFirstNameTrunCode" name="DriverFirstNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverFirstNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTranCode}    id="DriverFirstNameTranCode" name="DriverFirstNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="transliterated">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputMiddleName" className="form-label">Middle Name</label>
                            <input type="text" className="form-control" name="DriverMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={35} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTrunCode}  id="DriverMiddleNameTrunCode" name="DriverMiddleNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverMiddleNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTrunCode} id="DriverMiddleNameTranCode" name="DriverMiddleNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="transliterated">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label for="suffix">Suffix</label>
                            <select type="text" className="form-control form-select" name="Suffix" placeholder="" onChange={handleNameChange}>
                                <option defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.Suffix}> -- Suffix -- </option>
                                {suffix.map((val) => (
                                <option value={val}>{val}</option>
                            ))}
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="ssn">SSN</label>
                            <input type="text" className="form-control" name="SSN" minLength={9} maxLength={9} onInvalid={(e) => e.target.setCustomValidity('Invalid SSN')} pattern="^[0-9]{9}$" placeholder=""
                            defaultValue={data.formData.Body.DriverRequest.DriverData.SSN} onChange={handleDataChange} />
                        </div>
                        <div className="col-md-5">
                            <label for="inputDOB" className="form-label">Date of Birth</label>
                            <input type="date" className="form-control"
                                    placeholder="MM/DD/YYYY" 
                                    onKeyDown={(e) => disableKey(e)}
                                    onClick={handleSetCnDob}
                                    name='DriverDOB'
                                    defaultValue={formatDOB(data.formData?.Body?.DriverRequest?.DriverData?.DriverDOB)} 
                                    onChange={handleAkaChange} max={moment().format("YYYY-MM-DD")}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' />
                        </div>
                    </div>
                    
                    </form>
                    <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                    <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>
                    
            </div>);
        case 'akasearch':
            
            return(<div id='table'>
                <div id='banner-search'>
                    <h4>Request for Driver AKA</h4>
                </div>
                <div hidden={validForm}>
                    <span>Form invalid</span>
                </div>
                <form className='form' id="Index-form" onSubmit={handleSubmit}>
                    <span style={{ color: 'red', fontSize: 'small' }}>{akaDateErr}</span>                           
                    {showError && (
                    <div style={{ color: 'red', fontSize: 'small' }}>
                        {Object.entries(warnings).map(([key, value]) => {
                        if (Array.isArray(value)) {
                            // For array warnings like akaLastTrun
                            return value
                            .filter(v => v) // remove empty strings
                            .map((msg, i) => <div key={`${key}-${i}`}>{msg}</div>);
                        } else if (value) {
                            // For single string warnings
                            return <div key={key}>{value}</div>;
                        }
                        return null; // skip empty
                        })}
                    </div>
                    )}
                    <div className="row">
                        <div className="col-md-5">
                           <label for="inputDOB" className="form-label">Date of Birth</label>
                            <input type="date" className="form-control" 
                            placeholder="MM/DD/YYYY" name='DriverDOB' 
                            id="required-input" max={moment().format("YYYY-MM-DD")}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverDOB} 
                            onClick={handleSetCnDob}
                            onChange={handleDataChange}
                            onKeyDown={(e) => disableKey(e)}
                            pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}'
                            required/>

                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputLastName" className="form-label">Last Name</label>
                            <input type="text" className="form-control is-invalid" id="required-input" maxLength={40} style={{textTransform:'uppercase'}}
                            name="DriverLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastName} onChange={handleNameChange} required/> 
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTrunCode}  id="DriverLastNameTrunCode" name="DriverLastNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverLastNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTranCode} id="DriverLastNameTranCode" name="DriverLastNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="transliterated">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputFirstName" className="form-label">First Name</label>
                            <input type="text" className="form-control" id="inputFirstName" name="DriverFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTrunCode}  id="DriverFirstNameTrunCode" name="DriverFirstNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverFirstNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTranCode}  id="DriverFirstNameTranCode" name="DriverFirstNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="transliterated">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputMiddleName" className="form-label">Middle Name</label>
                            <input type="text" className="form-control" id="inputMiddleName" name="DriverMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={35} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTrunCode} id="DriverMiddleNameTrunCode" name="DriverMiddleNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverMiddleNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTranCode} id="DriverMiddleNameTranCode" name="DriverMiddleNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="transliterated">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label for="suffix">Suffix</label>
                            <select type="text" className="form-control form-select" name="Suffix" placeholder="" id="suffix" onChange={handleNameChange}>
                                <option defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.Suffix}> -- Suffix -- </option>
                                {suffix.map((val) => (
                                <option value={val}>{val}</option>
                            ))}
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="ssn">SSN</label>
                            <input type="text" className="form-control" id="ssn" placeholder="" name="SSN" minLength={9} maxLength={9} onInvalid={(e) => e.target.setCustomValidity('Invalid SSN')} pattern="^[0-9]{9}$"
                            defaultValue={data.formData.Body.DriverRequest.DriverData.SSN} onChange={handleDataChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="validationDefault04">State</label>
                            <input type="text" className="form-control" id="validationDefault04" placeholder="State" minLength={2} maxLength={2} pattern="^[A-Za-z0-9]{2}$" onInvalid={(e) => e.target.setCustomValidity('Invalid Jurisdiction entered')} style={{textTransform:'uppercase'}}
                            name="LicenseState" defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseState} onChange={handleLicenseChange} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label for="dlNumber">Driver License Number</label>
                            <input type="text" className="form-control" id="dlNumber" placeholder="" name="LicenseNumber" maxLength={25} pattern="^[a-zA-Z0-9-]*$" style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverLicense.LicenseNumber} onChange={handleLicenseChange} />
                        </div>
                        
                    </div>
                    
                    {count >= 1 &&
                    <><div className="row" data-index="0"  style={{borderTop: '1px solid black'}}>
                        <h4>AKA 1</h4>
                            <div className="col-md-5">
                                <label for="inputDOB" className="form-label">Date of Birth</label>
                                 <input type="date" className="form-control"
                                    placeholder="MM/DD/YYYY" data-index="0"  
                                    name='DriverAkaDOB' onChange={handleAkaChange} 
                                    onKeyDown={(e) => disableKey(e)}
                                    onClick={handleSetCnDob}
                                    max={moment().format("YYYY-MM-DD")}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' />

                            </div>
                        </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputLastName" className="form-label">Last Name</label>
                                    <input type="text" className="form-control" data-index="0"  maxLength={40} style={{textTransform:'uppercase'}} defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaLastName}
                                        name="AkaLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="0"  name="AkaLastNameTrunCode"onChange={handleAkaChange} checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaLastNameTrunCode === 'T'}/>
                                    <label className="form-check-label" for="AkaLastNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="0"  name="AkaLastNameTranCode" onChange={handleAkaChange} checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaLastNameTranCode === 'T'}/>
                                    <label className="form-check-label" for="AkaLastNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputFirstName" className="form-label">First Name</label>
                                    <input type="text" className="form-control" data-index="0"  name="AkaFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}} 
                                    defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaFirstName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="0"  name="AkaFirstNameTrunCode"
                                    checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaFirstNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaFirstNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="0"  name="AkaFirstNameTranCode"
                                    checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaFirstNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaFirstNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputMiddleName" className="form-label">Middle Name</label>
                                    <input type="text" className="form-control" data-index="0"  name="AkaMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={35} style={{textTransform:'uppercase'}} 
                                    defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaMiddleName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="0"  name="AkaMiddleNameTrunCode"
                                     checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaMiddleNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaMiddleNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="0"  name="AkaMiddleNameTranCode" 
                                    checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.AkaMiddleNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaMiddleNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-3 mb-3">
                                    <label for="suffix">Suffix</label>
                                    <select type="text" className="form-control form-select" name="Suffix" placeholder="" data-index="0" onChange={handleAkaChange}>
                                        <option defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[0]?.Suffix}> -- Suffix -- </option>
                                        {suffix.map((val) => (
                                        <option value={val}>{val}</option>
                                    ))}
                                    </select>
                                </div>
                            </div></>}
                    {count >= 2 &&
                    <><div className="row" data-index="1"  style={{borderTop: '1px solid black'}}>
                        <h4>AKA 2</h4>
                            <div className="col-md-5">
                                <label for="inputDOB" className="form-label">Date of Birth</label>
                                <input type="date" className="form-control"
                                    placeholder="MM/DD/YYYY" data-index="1"  
                                    name='DriverAkaDOB' 
                                    onKeyDown={(e) => disableKey(e)}
                                    onClick={handleSetCnDob}
                                    onChange={handleAkaChange} max={moment().format("YYYY-MM-DD")}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' />
                            </div>
                        </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputLastName" className="form-label">Last Name</label>
                                    <input type="text" className="form-control" data-index="1"  maxLength={40} style={{textTransform:'uppercase'}}
                                        name="AkaLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} 
defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaLastName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="1"  name="AkaLastNameTrunCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaLastNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaLastNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" data-index="1" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaLastNameTranCode === 'T'} name="AkaLastNameTranCode" onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaLastNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputFirstName" className="form-label">First Name</label>
                                    <input type="text" className="form-control" data-index="1"  name="AkaFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} style={{textTransform:'uppercase'}} 
defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaFirstName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="1"  maxLength={40} name="AkaFirstNameTrunCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaFirstNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaFirstNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="1"  name="AkaFirstNameTranCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaFirstNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaFirstNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputMiddleName" className="form-label">Middle Name</label>
                                    <input type="text" className="form-control" data-index="1"  maxLength={35} name="AkaMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} style={{textTransform:'uppercase'}} 
defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaMiddleName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="1"  name="AkaMiddleNameTrunCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaMiddleNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaMiddleNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="1"  name="AkaMiddleNameTranCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.AkaMiddleNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaMiddleNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-3 mb-3">
                                    <label for="suffix">Suffix</label>
                                    <select type="text" className="form-control form-select" name="Suffix" placeholder="" data-index="1" onChange={handleAkaChange}>
                                        <option defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[1]?.Suffix}> -- Suffix -- </option>
                                        {suffix.map((val) => (
                                        <option value={val}>{val}</option>
                                    ))}
                                    </select>
                                </div>
                            </div></>}
                    {count === 3 &&
                    <><div className="row" data-index="2"  style={{borderTop: '1px solid black'}}>
                        <h4>AKA 3</h4>
                            <div className="col-md-5">
                                <label for="inputDOB" className="form-label">Date of Birth</label>
                                <input type="date" className="form-control"
                                    placeholder="MM/DD/YYYY" data-index="2"  name='DriverAkaDOB' 
                                    onKeyDown={(e) => disableKey(e)}
                                    onClick={handleSetCnDob}
                                    onChange={handleAkaChange} max={moment().format("YYYY-MM-DD")}
                                    pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' />
                            </div>
                        </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputLastName" className="form-label">Last Name</label>
                                    <input type="text" className="form-control" data-index="2"  maxLength={40} style={{textTransform:'uppercase'}}
                                        name="AkaLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} 
defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaLastName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="2"  name="AkaLastNameTrunCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaLastNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaLastNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="2"  name="AkaLastNameTranCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaLastNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaLastNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputFirstName" className="form-label">First Name</label>
                                    <input type="text" className="form-control" data-index="2"  name="AkaFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} style={{textTransform:'uppercase'}} 
defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaFirstName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="2"  maxLength={40} name="AkaFirstNameTrunCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaFirstNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaFirstNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="2"  name="AkaFirstNameTranCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaFirstNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaFirstNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-6">
                                    <label for="inputMiddleName" className="form-label">Middle Name</label>
                                    <input type="text" className="form-control" data-index="2"  maxLength={35} name="AkaMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} style={{textTransform:'uppercase'}} 
defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaMiddleName} onChange={handleAkaChange} />
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="2"  name="AkaMiddleNameTrunCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaMiddleNameTrunCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaMiddleNameTrunCode">
                                        Truncated
                                    </label>
                                </div>
                                <div className="col" style={{ alignContent: 'end' }}>
                                    <input className="form-check-input" type="checkbox" value="" data-index="2"  name="AkaMiddleNameTranCode" checked={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.AkaMiddleNameTranCode === 'T'} onChange={handleAkaChange}/>
                                    <label className="form-check-label" for="AkaMiddleNameTranCode">
                                        Transliterated
                                    </label>
                                </div>
                            </div><div className="row">
                                <div className="col-md-3 mb-3">
                                    <label for="suffix">Suffix</label>
                                    <select type="text" className="form-control form-select" name="Suffix" placeholder="" data-index="2" onChange={handleAkaChange}>
                                        <option defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverNameAka[2]?.Suffix}> -- Suffix -- </option>
                                        {suffix.map((val) => (
                                        <option value={val}>{val}</option>
                                    ))}
                                    </select>
                                </div>
                            </div></>}
                    
                    
                    </form>
                    {count < 3 && <div className="col-md-1" style={{alignContent: 'center'}}>
                        <OverlayTrigger
                        placement="top"
                        overlay={<Tooltip id="button-tooltip-2">Add Another Driver AKA (up to 3)</Tooltip>}
                        >
                        <img src={add_circle} alt='add_circle' width={'20px'} onClick={() => setCount(count + 1)} />
                        </OverlayTrigger>
                    </div>}
                    
                    <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                    <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>
                    
            </div>);
        case 'inquirysearch':
            console.log("Inquiry: ", data.selectionRequest.country);
            if(data.selectionRequest.country === 'CA' && !roles.includes('searchCnFcwd')){
                return(<div id='table'>
                    <div id='banner-search'>
                        <h4>Request for Driver Inquiry</h4>
                    </div>
                    <div hidden={validForm}>
                        <span>Form invalid</span>
                    </div>
                    <form className='form' id="Index-form" onSubmit={handleSubmit}>
                    <span style={{ color: 'red', fontSize: 'small' }}>{akaDateErr}</span>                           
                        <div className="row">
                        <div className="col-md-3 mb-3">
                                <label for="state">State</label>
                                <input type="text" className="form-control is-invalid" id="required-input" placeholder="State" onInvalid={(e) => e.target.setCustomValidity('Invalid Jurisdiction entered')} name="LicenseState" style={{textTransform:'uppercase'}}
                                defaultValue={data.formData.Body.DriverRequest.DriverData.DriverLicense.LicenseState} onChange={handleLicenseChange} required/>
                            </div>
                            <div className="col-md-6 mb-3">
                                <label for="dlNumber">Driver License Number</label>
                                <input type="text" className="form-control is-invalid" id="required-input" placeholder="" name="LicenseNumber" maxLength={27} pattern="^[a-zA-Z0-9-]*$" style={{textTransform:'uppercase'}}
                                defaultValue={data.formData.Body.DriverRequest.DriverData.DriverLicense.LicenseNumber} onChange={handleLicenseChange} required/>
                                
                            </div>
                        </div>
                        
                        <div className="row">
                            <div className="col-md-6">
                                <label for="inputLastName" className="form-label">Last Name</label>
                                <input type="text" className="form-control is-invalid" id="required-input" name="DriverLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                                defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastName} onChange={handleNameChange} required/>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-6">
                                <label for="inputFirstName" className="form-label">First Name</label>
                                <input type="text" className="form-control" name="DriverFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}} defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstName} onChange={handleNameChange} />
                            </div>
                                <small>*First Name is required to match the Canadian Record. If the driver has only one name or a period(.) as a first name, the field may be left blank.</small>
                        </div>
                        <div className="row">
                            <div className="col-md-5">
                                <label for="inputDOB" className="form-label">Date of Birth</label>
                            <input type="date" className="form-control is-invalid" 
                                id="required-input" 
                                placeholder="MM/DD/YYYY" 
                                onKeyDown={(e) => disableKey(e)}
                                name='DriverDOB'
                                defaultValue={data.formData?.Body?.DriverRequest?.DriverData?.DriverDOB} 
                                onChange={handleDataChange} 
                                onClick={handleSetCnDob}
                                max={moment().format("YYYY-MM-DD")}
                                pattern='(0[1-9]|1[1,2])(\/|-)(0[1-9]|[12][0-9]|3[01])(\/|-)(19|20)\d{2}' 
                                required/>
                            </div>
                        </div>
                        
                        </form>
                        <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                        <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>
                        
                </div>);
            }
            return(<div id='table'>
                <div id='banner-search'>
                    <h4>Request for Driver Inquiry</h4>
                </div>
                <div hidden={validForm}>
                    <span>Form invalid</span>
                </div>
                <form className='form' id="Index-form" onSubmit={handleSubmit}>
                    <div className="row">
                    <div className="col-md-3 mb-3">
                            <label for="state">State</label>
                            <input type="text" className="form-control is-invalid" id="required-input" placeholder="State" onInvalid={(e) => e.target.setCustomValidity('Invalid Jurisdiction entered')} name="LicenseState" style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseState} onChange={handleLicenseChange} required/>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label for="dlNumber">Driver License Number</label>
                            <input type="text" className="form-control is-invalid" id="required-input" placeholder="" name="LicenseNumber" maxLength={27} pattern="^[a-zA-Z0-9-]*$" style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverLicense.LicenseNumber} onChange={handleLicenseChange} required/>
                            
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputLastName" className="form-label">Last Name</label>
                            <input className="form-control" type="text" name="DriverLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} style={{textTransform:'uppercase'}} disabled/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6" readonly="readonly">
                            <label for="inputFirstName" className="form-label">First Name</label>
                            <input type="text" className="form-control" name="DriverFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} style={{textTransform:'uppercase'}} disabled/>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5">
                            <label for="inputDOB" className="form-label">Date of Birth</label>
                            <input type="date" className="form-control" placeholder="MM/DD/YYYY" name='DriverDOB' disabled/>
                            
                        </div>
                    </div>
                    
                    </form>
                    <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                    <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>
                    
            </div>);
        case 'vehiclesearch':
            return(<><div  className="alert alert-danger" role="alert" hidden={validForm}>
                <span>{vehicleErr}</span> 
            </div><div id='table'>
                    <div id='banner-search'>
                        <h4>Request Carrier and Vehicle Search</h4>
                    </div>

                    <form className='form' id="Index-form" onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col">
                                <label for="dlNumber">Plate</label>
                                <input type="text" className="form-control" name="Plate" style={{textTransform:'uppercase'}}
                                    defaultValue={data.formData.Body.VehicleRequest.PLATE} onChange={handleVehicleChange} />

                            </div>
                        </div>
                        <p> -OR-</p>
                        <div className="row">
                            <div className="col">
                                <label for="dlNumber">VIN</label>
                                <input type="text" className="form-control" name="VIN" style={{textTransform:'uppercase'}}
                                    defaultValue={data.formData.Body.VehicleRequest.VIN} onChange={handleVehicleChange} />

                            </div>
                        </div>
                        <p> -OR-</p>
                        <div className="row">
                            <div className="col">
                                <label for="dlNumber">RFC</label>
                                <input type="text" className="form-control" name="RFC" style={{textTransform:'uppercase'}}
                                    defaultValue={data.formData.Body.VehicleRequest.RFC} onChange={handleVehicleChange} />

                            </div>
                        </div>

                    </form>
                    <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                    <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>

                </div></>)
        case 'minimalsearch':

            return (<div id='table'>
                <div id='banner-search'>
                    <h4>Request for Driver Minimal</h4>
                </div>
                <div hidden={validForm}>
                    <span>Form invalid</span>
                </div>
                <form id="Index-form" name="form" onSubmit={handleSubmit}>
                    {showError && (
                    <div style={{ color: 'red', fontSize: 'small' }}>
                        {Object.entries(warnings).map(([key, value]) => {
                        if (Array.isArray(value)) {
                            // For array warnings like akaLastTrun
                            return value
                            .filter(v => v) // remove empty strings
                            .map((msg, i) => <div key={`${key}-${i}`}>{msg}</div>);
                        } else if (value) {
                            // For single string warnings
                            return <div key={key}>{value}</div>;
                        }
                        return null; // skip empty
                        })}
                    </div>
                    )}
                    
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputLastName" className="form-label">Last Name</label>
                            <input type="text" className="form-control is-invalid" id="required-input" maxLength={40} style={{textTransform:'uppercase'}}
                            name="DriverLastName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastName} onChange={handleNameChange} required/>   
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTrunCode} id="DriverLastNameTrunCode" name="DriverLastNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverLastNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverLastNameTranCode} id="DriverLastNameTranCode" name="DriverLastNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverLastNameTranCode">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputFirstName" className="form-label">First Name</label>
                            <input type="text" className="form-control" id="inputFirstName" name="DriverFirstName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={40} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTrunCode} id="DriverFirstNameTrunCode" name="DriverFirstNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverFirstNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverFirstNameTranCode} id="DriverFirstNameTranCode" name="DriverFirstNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverFirstNameTranCode">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label for="inputMiddleName" className="form-label">Middle Name</label>
                            <input type="text" className="form-control" id="inputMiddleName" name="DriverMiddleName" pattern={"^[A-Za-z0-9 !\"#%&'()*+,\-./:;<=>?@\[\\\]^_`{|}~]*$"} maxLength={35} style={{textTransform:'uppercase'}}
                            defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleName} onChange={handleNameChange} />
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTrunCode} id="DriverMiddleNameTrunCode" name="DriverMiddleNameTrunCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverMiddleNameTrunCode">
                                Truncated
                            </label>
                        </div>
                        <div className="col" style={{alignContent: 'end'}}>
                            <input className="form-check-input" type="checkbox" defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.DriverMiddleNameTranCode} id="DriverMiddleNameTranCode" name="DriverMiddleNameTranCode" onChange={toggleRequired}/>
                            <label className="form-check-label" for="DriverMiddleNameTranCode">
                                Transliterated
                            </label>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-3 mb-3">
                            <label for="suffix">Suffix</label>
                            <select type="text" className="form-control form-select" name="Suffix" placeholder="" id="suffix" onChange={handleNameChange}>
                                <option defaultValue={data.formData.Body.DriverRequest.DriverData.DriverName.Suffix}> -- Suffix -- </option>
                                {suffix.map((val) => (
                                <option value={val}>{val}</option>
                            ))}
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="Age">Age</label>
                            <input type="text" className="form-control" id="Age" placeholder="" name="Age"
                            defaultValue={data.formData.Body.DriverRequest.Age} onChange={handleDataChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="YearSearchRange">Year Range</label>
                            <input type="text" className="form-control" id="YearSearchRange"
                            name="YearSearchRange" defaultValue={data.formData.Body.DriverRequest.YearSearchRange} onChange={handleDataChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="FirstMatchSequence">Begin At Message #</label>
                            <input type="text" className="form-control" id="FirstMatchSequence" placeholder="" name="FirstMatchSequence"
                            defaultValue={data.formData.Body.DriverRequest.FirstMatchSequence} onChange={handleDataChange} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label for="MessageMatchCount"># of Messages Requested (1-99)</label>
                            <input type="text" className="form-control" id="MessageMatchCount" placeholder="" name="MessageMatchCount"
                            defaultValue={data.formData.Body.DriverRequest.MessageMatchCount} onChange={handleDataChange} />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <label htmlFor="selectedJurisdictions" className="form-label">Select States</label>
                            <br/>
                            <span><b>
                                **Search defaults to all States or select a maximum of 10 States.</b>
                            </span>
                            <ul className="list-group border" style={{ maxHeight: '400px', overflowY: 'auto', padding: '15px', marginBottom: '20px'}}>
                                {countryOptions.US.map((state, index) => {
                                    const isChecked = selectedStates.includes(state.code);
                                    const disableCheckbox = selectedStates.length >= 10 && !isChecked;

                                    return (
                                        <li className="list-group-item" key={state.code}>
                                                <input
                                                    className="form-check-input me-1"
                                                    type="checkbox"
                                                    value={state.code}
                                                    id={`selectedJurisdictions-${index}`}
                                                    checked={isChecked}
                                                    disabled={disableCheckbox}
                                                    onChange={(e) => handleSelectChange(state.code, e.target.checked)}
                                                />
                                                    {state.label}
                                        </li>
                                    );
                                })}
                            </ul>
                            
                            <div>
                                <button
                                    type="button"
                                    className="btn btn-outline-primary btn-sm"
                                    onClick={clearSelected} // 👈 clears all selections
                                >
                                    Clear All
                                </button>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <label className="form-label d-flex justify-content-between">
                            <span>Selected States (order of selection)</span>
                            <span className="text-muted">{selectedStates.length}/10</span>
                            </label>

                            {selectedStates.length === 0 ? (
                            <div className="text-muted">No states selected.</div>
                            ) : (
                            <ol className="list-group list-group-numbered">
                                {selectedStates.map((code) => (
                                <li key={code} className="list-group-item d-flex justify-content-between align-items-center">
                                    <span>{codeToLabel[code] ?? code}</span>
                                    <button
                                    type="button"
                                    className="btn btn-sm btn-outline-danger"
                                    onClick={() => handleSelectChange(code, false)}
                                    aria-label={`Remove ${codeToLabel[code] ?? code}`}
                                    >
                                    Remove
                                    </button>
                                </li>
                                ))}
                            </ol>
                            )}
                        </div>
                    </div>
                    </form>
                    <button type="submit" className="btn btn-primary" id="button" form='Index-form'>Search</button>
                    <a href='/'><button type="button" className="btn btn-primary" id="button">Cancel</button></a>
                    
            </div>);
        case 'noMxDriver':
            return(
                <h1>No MX Driver Found: Create</h1>
            );

       default:
            break;
    }
};

export default MyForm;